const loadPolyfills = (): void => {
  // BEGIN polyfill_flatMap
  if (!Array.prototype.flatMap) {
    Object.defineProperty(Array.prototype, 'flatMap', {
      value: function(callback, thisArg) {
        const self = thisArg || this;
        if (self === null) {
          throw new TypeError('Array.prototype.flatMap ' + 'called on null or undefined');
        }
        if (typeof callback !== 'function') {
          throw new TypeError(callback + ' is not a function');
        }

        let list = [];

        const o = Object(self);

        const len = o.length >>> 0;

        for (let k = 0; k < len; ++k) {
          if (k in o) {
            const part_list = callback.call(self, o[k], k, o);
            list = list.concat(part_list);
          }
        }

        return list;
      },
    });
  }
  // END polyfill_flatMap
};

export default loadPolyfills;
